export default "__VITE_ASSET__sRhrTqFu__"